
import PreviewDevice from '@/components/PreviewDevice/index.vue';

export default {
  components: {
    PreviewDevice: PreviewDevice
  },
  props: ['url'],
  data: function data() {
    return {
      type: '2'
    };
  }
};